import { combineReducers } from 'redux'
import video from './video'
import videos from './videos'
import me from './me'
import clipper from './clipper'
import stats from './stats'
import ads from './ads'
import search from './search'

const rootReducer = combineReducers({
  video,
  videos,
  me,
  clipper,
  stats,
  ads,
  search,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js